import React, { useMemo } from "react";
import { DataTable, HorizontalDivider, PriorityIcon, Table } from "@sscs/ui";
import { useParams } from "react-router";
import { FILE_BROWSER_ROUTES, REPORT_PAGES_ROUTES, } from "../../../../constants";
import { filterByLink } from "../../../../store/issuesSlice";
import { ExpandedRowDetails } from "../../../../ui";
import { LinkToReportTab, PolicyAudit, PolicyEnabled, PolicyRecommendation, StatusLabel, } from "../../../common";
import { useReportDispatch } from "../../../hooks";
import { useGetComponentInfoQuery } from "../../../services/fileBrowser.api";
import { generateFileBrowserTabLink } from "../../../utils";
import { filterByBehaviorId } from "../../store/behaviorSlice";
import { useGetFileAndReportId } from "../../useGetFileAndReportId";
import { usePolicyMappings } from "./PolicyMappings";
import styles from "./policyRule.module.scss";
const CausedBy = ({ id, rootCause, }) => {
    const dispatch = useReportDispatch();
    const { fileId = "" } = useParams();
    const policyMappingsMap = usePolicyMappings();
    if (policyMappingsMap[id]) {
        return (React.createElement("div", { className: styles["root-cause"] },
            "Caused by:",
            " ",
            React.createElement(LinkToReportTab, { id: `cause-${policyMappingsMap[id].text}`, to: policyMappingsMap[id].to, onClick: policyMappingsMap[id].onClick }, policyMappingsMap[id].text)));
    }
    if (rootCause.length > 0) {
        return (React.createElement("div", { className: styles["root-cause"] },
            "Caused by:",
            " ",
            rootCause.map((cause, index) => (React.createElement(React.Fragment, null,
                index > 0 ? ", " : "",
                React.createElement(LinkToReportTab, { key: cause, id: `cause-${cause}`, to: generateFileBrowserTabLink(fileId, FILE_BROWSER_ROUTES.BEHAVIOR_ROUTE), onClick: () => dispatch(filterByBehaviorId(cause)) }, cause))))));
    }
    return null;
};
const PolicyRule = ({ id, policy, focused, onClick, }) => {
    const dispatch = useReportDispatch();
    const { fileId, reportId } = useGetFileAndReportId();
    const { data: componentInfo } = useGetComponentInfoQuery({
        reportId,
        fileId: fileId !== null && fileId !== void 0 ? fileId : "",
    });
    const rootCause = useMemo(() => {
        const result = [];
        if (!(componentInfo === null || componentInfo === void 0 ? void 0 : componentInfo.transparency))
            return result;
        Object.entries(componentInfo.transparency.via_policy).forEach(([behaviorId, trigger]) => {
            if (trigger.violations.includes(policy.id)) {
                return result.push(behaviorId);
            }
        });
        return result;
    }, [componentInfo === null || componentInfo === void 0 ? void 0 : componentInfo.transparency, policy.id]);
    return (React.createElement(DataTable.ExpandedRow, { id: id, focused: focused, onClick: onClick, className: policy.status === "fail" ? styles["fail-row"] : "" },
        React.createElement(DataTable.ExpandedRow.Summary, null,
            React.createElement(Table.Cell, null,
                React.createElement(LinkToReportTab, { id: `${id}-issue-link`, to: REPORT_PAGES_ROUTES.ISSUES_ROUTE, color: "link", onClick: () => dispatch(filterByLink({
                        issue: { operation: "is", values: [policy.id] },
                    })), className: styles.link }, policy.id)),
            React.createElement(Table.Cell, null,
                policy.description,
                React.createElement(CausedBy, { id: policy.id, rootCause: rootCause })),
            React.createElement(Table.Cell, null,
                React.createElement(PolicyEnabled, { enabled: policy.enabled })),
            React.createElement(Table.Cell, null,
                React.createElement(PriorityIcon, { grade: policy.grade, hasIssues: true, status: policy.status })),
            React.createElement(Table.Cell, null,
                React.createElement(StatusLabel, { level: policy.level, status: policy.status, enabled: policy.enabled }))),
        React.createElement(DataTable.ExpandedRow.Details, null,
            React.createElement(ExpandedRowDetails, null,
                policy.audit.present ? (React.createElement(React.Fragment, null,
                    React.createElement(PolicyAudit, { audit: policy.audit }),
                    React.createElement(HorizontalDivider, null))) : null,
                React.createElement(PolicyRecommendation, { recommendation: policy.recommendation, effort: policy.effort, violationCount: 1 })))));
};
export default PolicyRule;
//# sourceMappingURL=PolicyRule.js.map